import { resolveAssetWatchCognitoConfig } from "@assetwatch/auth";

const cognito = resolveAssetWatchCognitoConfig({
  allowFallback: import.meta.env.DEV,
  deployEnvironment: import.meta.env.VITE_DEPLOY_ENVIRONMENT,
  injectedConfig: {
    USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
    IDENTITY_POOL_ID: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
    DOMAIN: import.meta.env.VITE_COGNITO_DOMAIN,
  },
});

const deployEnvironment = import.meta.env.VITE_DEPLOY_ENVIRONMENT ?? "dev";
const mlApiBaseUrl =
  (import.meta.env.VITE_ML_API_BASE_URL as string | undefined)?.replace(
    /\/$/,
    "",
  ) ?? "https://ml.dev.assetwatch.com";

export default {
  appName: "ML Frontend",
  deployEnvironment,
  mlApi: {
    baseUrl: mlApiBaseUrl,
    // One endpoint per R&D page: /v1/frontend/<page>. Pages are independent —
    // a page must never need to call another page's endpoint to render.
    frontendPath: "/v1/frontend",
  },
  cognito: {
    USER_POOL_ID: cognito.USER_POOL_ID,
    APP_CLIENT_ID: cognito.APP_CLIENT_ID,
    IDENTITY_POOL_ID: cognito.IDENTITY_POOL_ID,
    DOMAIN: cognito.DOMAIN,
  },
};
